import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Card } from "reactstrap";

import { Block, BlockBetween, BlockTitle, Row, Col } from "../../Component";
import DropzoneInput from "../../input/dropzone/DropzoneInput";
import BlockUpdateButton from "../../button/BlockUpdateButton";

import partnerService from "../../../services/partnerService";
import { useBeManualFetcher } from "../../../hooks/useBeManualFetcher";
import { usePartnerPageContext } from "../../../hooks/usePartnerPageContext";
import EventEmitter, { EVENT_TOPICS } from "../../../utilities/eventUtils";

const PartnerMediaBlock = () => {
  const { partnerId } = useParams();
  const { handleSubmit } = useForm();
  const [onFetch] = useBeManualFetcher();
  const { singlePartner } = usePartnerPageContext();

  const [hasEditClicked, setHasEditClicked] = useState(false);
  const [logo, setLogo] = useState([]);
  const [gallery, setGallery] = useState([]);

  function handleOnEditClicked() {
    setHasEditClicked((prev) => !prev);
  }

  async function onFormSubmit() {
    // Rasm o'zgarmasa yubormaymiz — backend null maydonlarni o'zgartirmaydi.
    return await onFetch({
      action: () =>
        partnerService.updatePartner(partnerId, {
          data: {},
          logo: logo?.[0],
          gallery,
        }),
      onLoad: (updatedPartner) => {
        EventEmitter.emit(EVENT_TOPICS.ON_PARTNER_UPDATED, { updatedPartner });
        setLogo([]);
        setGallery([]);
        handleOnEditClicked();
      },
      successMessage: "Partner images updated successfully",
    });
  }

  return (
    <Card className="card-inner">
      <Block>
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <BlockBetween>
            <BlockTitle tag="h5">Logo & Gallery</BlockTitle>
            <BlockUpdateButton
              hasEditClicked={hasEditClicked}
              handleOnEditClicked={handleOnEditClicked}
            />
          </BlockBetween>
          {hasEditClicked ? (
            <Row className="mt-3">
              <Col md="4" className="mb-3">
                <label className="form-label">Logo</label>
                <DropzoneInput files={logo} setFiles={setLogo} />
              </Col>
              <Col md="8" className="mb-3">
                <label className="form-label">Gallery</label>
                <DropzoneInput files={gallery} setFiles={setGallery} multiple />
              </Col>
            </Row>
          ) : (
            <Row className="mt-3">
              <Col md="auto" className="mb-4">
                <label className="form-label">Logo</label>
                {singlePartner?.logo ? (
                  <a
                    href={singlePartner.logo}
                    target="_blank"
                    rel="noreferrer"
                    className="d-flex align-items-center justify-content-center border rounded bg-lighter p-3"
                    style={{ width: 150, height: 150 }}
                  >
                    <img
                      src={singlePartner.logo}
                      alt="logo"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </a>
                ) : (
                  <div className="text-soft">No logo</div>
                )}
              </Col>
              <Col className="col mb-4">
                <div className="d-flex align-items-center mb-2">
                  <label className="form-label mb-0">Gallery</label>
                  <span className="badge badge-dim badge-light ml-2">
                    {singlePartner?.gallery?.length ?? 0}
                  </span>
                </div>
                {singlePartner?.gallery?.length > 0 ? (
                  // Rasmlar har xil nisbatda — bir xil kvadrat tayl'larga
                  // kesib ko'rsatamiz, to'liq rasm bosilganda ochiladi.
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(150px, 1fr))",
                      gap: 12,
                    }}
                  >
                    {singlePartner.gallery.map((src, index) => (
                      <a
                        key={src}
                        href={src}
                        target="_blank"
                        rel="noreferrer"
                        className="d-block border rounded overflow-hidden bg-lighter"
                        style={{ aspectRatio: "1 / 1" }}
                      >
                        <img
                          src={src}
                          alt={`gallery-${index + 1}`}
                          loading="lazy"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </a>
                    ))}
                  </div>
                ) : (
                  <div className="text-soft">No images</div>
                )}
              </Col>
            </Row>
          )}
        </form>
      </Block>
    </Card>
  );
};

export default PartnerMediaBlock;
